<template>
  <nav role="navigation" class="app-navigation">
    <div class="inner-width">
      <button @click="showMenu = !showMenu"></button>
      <ul :class="{ open: showMenu}">
        <li v-for="(link, id) in links" :key="id">
          <!--
          <router-link :to="`/${ link.fields.uri_slug.text }`" exact>{{ link.fields.title.text }}</router-link>
          -->
          <router-link :to="`${ lowerCase(link.url) }`" exact>{{ link.fields.title.text }}</router-link>
        </li>
        <li>
          <a href="https://eportal.fagbokforlaget.no">Logg inn</a>
        </li>
      </ul>
    </div>
  </nav>
</template>


<script>
import { baseCmsUrl, baseCmsNode } from '../../config';

export default {
  name: 'AppNavigation',
  data() { 
    return {
      links: [],
      showMenu: false
    }
  },
  methods: {
    toggleMenu() {
      this.showMenu = !this.showMenu;
      alert(this.showMenu);
    },
    lowerCase(slug) {
      return slug.toLowerCase();
    }
  },
  mounted() {
    
    this.$http.get(`${baseCmsUrl}node/${baseCmsNode}children?depth=10&fields=title,uri_slug`).then((response) => {
      for (let [linkId, link] of response.data.entries()) {
        if (link.type_identifier == 'page') {

          if (link.fields.title.text != 'Demo') {
            if (link.fields.title.text == 'Produkter') {
              this.links.push({
                fields: {
                  title: {
                    text: 'Produkter'
                  }
                },
                url: '/produkt/alfa'
              });
            } else {
              this.links.push(link);
            }


          }

        }
      }

      console.log('link: ', this.links);
      // return this.links = response.data;
    });
    
  }
}
</script>
